import { FC, useEffect, useMemo, useState } from 'react';
import { Header } from '../header/header';
import { Container } from '../container/container';
import { Footer } from '../footer/footer';
import { CancelButton } from '../shared/cancel-button/cancel-button';
import { INITIAL_QUANTITY, markups, fourPageEXW, fivePageEXW, minPages, INITIAL_FORM_DATA } from '../../constants';
import {
  getCoefFive,
  getCoefFour,
  getPriceEuro,
  getPriceEuroPerPiece,
  getPriceRubPerPiece,
  getEuroExchange,
} from '../../helpers';
import { FormData } from '../../types';

import './main-wrapper.css';

export const MainWrapper: FC = () => {
  const [formData, setFormData] = useState<FormData>(INITIAL_FORM_DATA);
  const [onePrice, setOnePrice] = useState<number>(0);
  const [euro, setEuro] = useState<number>(0);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const colorsCount = useMemo(() => {
    const printedPagesData = [...formData?.printedPagesData];
    const sortedPrintedPagesDataByColorCount = printedPagesData.sort((a: any, b: any) => b.colorCount - a.colorCount) as any;
    const greaterColorCount = sortedPrintedPagesDataByColorCount[0].colorCount + sortedPrintedPagesDataByColorCount[0].backSide;

    const remainingBackSidePageData = sortedPrintedPagesDataByColorCount.slice(1, sortedPrintedPagesDataByColorCount.length);

    const remainingBacksideColorCount = remainingBackSidePageData.filter(({ backSide }: any) => backSide).length;

    return greaterColorCount + remainingBacksideColorCount;
  }, [formData]);

  useEffect(() => {
    setEuro(0);
    getEuroExchange()
      .then((rate) => {
        setEuro(parseFloat(rate.dolar.replace(',', '.')));
      });
  }, []);

  useEffect(() => {
    const quantity = formData.quantity;
    const printedPagesData = formData.printedPagesData;
    const ifFourPage = printedPagesData.length === minPages;

    const quantityBorder = quantity - quantity % INITIAL_QUANTITY;
    const currentMarkup = markups[`${quantityBorder}`];
    const currentExw = ifFourPage ? fourPageEXW[`${quantityBorder}`] : fivePageEXW[`${quantityBorder}`];

    let printingPagesCount: number = 0;
    printedPagesData.forEach(page => printingPagesCount += page.colorCount + page.backSide + formData.barcode / printedPagesData.length);

    const priceEuro = getPriceEuro(quantity, quantityBorder, currentExw);
    const printingPagesCoef = ifFourPage ? getCoefFour(printingPagesCount) : getCoefFive(printingPagesCount);
    const priceEuroPerPiece = getPriceEuroPerPiece(priceEuro, printingPagesCoef, quantity, currentMarkup);
    const priceRubPerPiece = getPriceRubPerPiece(euro, priceEuroPerPiece);

    setOnePrice(Math.round(priceRubPerPiece * 100) / 100);
  }, [formData, euro]);

  useEffect(() => {
    if (showSuccess) {
      setFormData(INITIAL_FORM_DATA);
    }
  }, [showSuccess]);

  return (
    <div className="main-wrapper">
      {showSuccess && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-button"><CancelButton onCancel={() => location.reload()} /></span>
            <i className="fas fa-check-circle fa-5x"></i>
            <p>Официальное коммерческое предложение отправлено Вам на почту. <p> Спасибо что выбрали МАНФОЛ</p></p>
          </div>
        </div>
      )}
      <Header
        formData={formData}
        setFormData={setFormData}
      />
      <Container
        formData={formData}
        setFormData={setFormData}
      />
      <Footer
        setShowSuccess={setShowSuccess}
        quantity={formData.quantity}
        onePrice={onePrice}
        barcode={formData.barcode}
        totalPrice={Math.round(onePrice * formData.quantity)}
        colorsCount={colorsCount}
        listsCount={formData?.printedPagesData?.length}
        printedPagesData={formData.printedPagesData}
      />
    </div>
  );
};